var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubaruLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "152px",
    height: "24px",
    viewBox: "0 0 152 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Subaru_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.9882,12.0931 L54.2162,11.7561 C54.2162,11.7561 53.3422,11.7921 53.3372,10.7601 C53.3322,9.6551 54.1342,9.6001 54.2442,9.6001 L60.7952,9.6001 C61.9822,9.6001 61.9272,10.7031 61.9272,10.7031 L65.5082,10.7031 L65.5082,9.5131 C65.5082,6.7571 62.4572,6.8561 61.9582,6.8561 L53.6312,6.8561 C53.0642,6.8561 50.0552,7.0811 50.0552,10.9861 C50.0552,14.7471 53.6482,14.5291 53.6482,14.5291 L61.3922,14.7541 C61.3922,14.7541 62.2552,14.7191 62.2702,15.8381 C62.2872,17.0591 61.4202,17.0591 61.4202,17.0591 L54.6532,17.0591 C53.6332,17.0591 53.6332,15.7541 53.6332,15.7541 L50.0552,15.7541 L50.0552,16.6581 C50.0552,19.7411 53.1822,19.7981 53.6542,19.7981 L61.9582,19.7981 C65.4752,19.7981 65.5752,17.0471 65.5752,15.9591 C65.5752,12.0631 61.9882,12.0931 61.9882,12.0931",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.9%",
    y: "-15.5%",
    width: "125.8%",
    height: "130.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.9262,17.0672 L87.4312,17.0672 L87.4312,14.3792 L94.8412,14.3792 C94.8412,14.3792 95.9782,14.3492 95.9462,15.7082 C95.9112,17.0932 94.9262,17.0672 94.9262,17.0672 Z M87.4312,9.6272 L94.7282,9.6272 C94.7282,9.6272 95.6792,9.5842 95.6922,10.7302 C95.6922,10.7302 95.7482,11.9452 94.7552,11.9452 L87.4312,11.9452 L87.4312,9.6272 Z M97.8062,12.8992 C99.2992,12.0552 99.1442,10.4092 99.1442,9.6962 C99.1442,9.2532 98.8792,6.8612 96.1452,6.8612 L84.2392,6.8612 L84.2392,19.7742 L96.3142,19.7742 C99.0942,19.7742 99.2672,16.4182 99.2672,16.4182 C99.3482,13.2302 97.8062,12.8992 97.8062,12.8992 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.3%",
    y: "-15.5%",
    width: "126.6%",
    height: "131.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.5239,14.7884 L107.8989,10.2664 L110.2489,14.7894 L105.5239,14.7884 Z M106.0409,6.8354 L99.0409,19.7664 L102.9269,19.7664 L104.1629,17.5554 L111.6499,17.5554 L112.8859,19.7664 L116.9149,19.7664 L109.9009,6.8354 L106.0409,6.8354 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-11.2%",
    y: "-15.5%",
    width: "122.4%",
    height: "130.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.0595,12.1073 L121.1715,12.1073 L121.1715,9.7173 L128.0745,9.7173 C128.0745,9.7173 129.4005,9.5573 129.4005,10.9343 C129.4005,10.9343 129.5525,12.1073 128.0595,12.1073 M131.4265,13.6663 C132.8835,12.7663 132.7225,10.6883 132.7225,10.6883 C132.7225,9.5223 132.4105,6.8543 129.7465,6.8543 L117.7385,6.8543 L117.7385,19.7693 L121.1715,19.7663 L121.1715,15.1853 L128.0675,15.1853 C129.6085,15.1853 129.4945,16.4833 129.4945,17.7663 L129.4945,19.7663 L132.8665,19.7663 L132.8665,17.7423 C132.8665,14.2693 131.4265,13.6663 131.4265,13.6663",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.2%",
    y: "-15.5%",
    width: "126.4%",
    height: "131.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.9643,6.8524 L78.9643,15.3954 C78.9643,16.7244 77.9463,16.6874 77.9463,16.6874 L71.7763,16.6904 C70.5213,16.6904 70.5433,15.4174 70.5433,15.4174 L70.5433,6.8524 L67.1443,6.8524 L67.1443,16.7074 C67.1443,19.7934 70.5363,19.7744 70.5363,19.7744 L78.9993,19.7744 C78.9993,19.7744 82.3563,19.7464 82.3563,16.7044 C82.3563,15.9644 82.3733,6.8644 82.3733,6.8644 L78.9643,6.8524 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.1%",
    y: "-15.5%",
    width: "126.3%",
    height: "131.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.1323,6.8524 L146.1323,15.3954 C146.1323,16.7244 145.1143,16.6874 145.1143,16.6874 L138.9433,16.6904 C137.6873,16.6904 137.7123,15.4174 137.7123,15.4174 L137.7123,6.8524 L134.3113,6.8524 L134.3113,16.7074 C134.3113,19.7934 137.7033,19.7744 137.7033,19.7744 L146.1673,19.7744 C146.1673,19.7744 149.5233,19.7464 149.5233,16.7044 C149.5233,15.9644 149.5413,6.8644 149.5413,6.8644 L146.1323,6.8524 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.1%",
    y: "-15.5%",
    width: "126.3%",
    height: "131.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.5034,18.8006 L150.6264,18.8006 C150.7634,18.8006 150.8804,18.7506 150.8804,18.6206 C150.8804,18.5296 150.8134,18.4376 150.6264,18.4376 C150.5704,18.4376 150.5354,18.4416 150.5034,18.4466 L150.5034,18.8006 Z M150.5034,19.3806 L150.3384,19.3806 L150.3384,18.3346 C150.4264,18.3186 150.5084,18.3056 150.6344,18.3056 C150.7944,18.3056 150.8994,18.3426 150.9604,18.3896 C151.0234,18.4316 151.0574,18.5046 151.0574,18.6046 C151.0574,18.7416 150.9644,18.8256 150.8504,18.8586 L150.8504,18.8676 C150.9464,18.8846 151.0084,18.9696 151.0294,19.1236 C151.0534,19.2866 151.0784,19.3486 151.0964,19.3806 L150.9184,19.3806 C150.8934,19.3486 150.8704,19.2536 150.8484,19.1156 C150.8234,18.9816 150.7574,18.9316 150.6224,18.9316 L150.5034,18.9316 L150.5034,19.3806 Z M150.6804,18.0406 C150.2674,18.0406 149.9304,18.3966 149.9304,18.8326 C149.9304,19.2826 150.2674,19.6356 150.6864,19.6356 C151.1044,19.6396 151.4374,19.2826 151.4374,18.8376 C151.4374,18.3966 151.1044,18.0406 150.6864,18.0406 L150.6804,18.0406 Z M150.6864,17.8946 C151.1994,17.8946 151.6104,18.3106 151.6104,18.8326 C151.6104,19.3656 151.1994,19.7806 150.6804,19.7806 C150.1674,19.7806 149.7484,19.3656 149.7484,18.8326 C149.7484,18.3106 150.1674,17.8946 150.6804,17.8946 L150.6864,17.8946 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-107.4%",
    y: "-106.0%",
    width: "314.8%",
    height: "312.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5156,0.9862 C10.5856,0.9862 0.8796,6.2342 0.8796,12.6842 C0.8796,19.1332 10.5856,24.3802 22.5156,24.3802 C34.4466,24.3802 44.1526,19.1332 44.1526,12.6842 C44.1526,6.2342 34.4466,0.9862 22.5156,0.9862 M43.8806,12.6842 C43.8806,18.9842 34.2966,24.1092 22.5156,24.1092 C10.7356,24.1092 1.1516,18.9842 1.1516,12.6842 C1.1516,6.3832 10.7356,1.2572 22.5156,1.2572 C34.2966,1.2572 43.8806,6.3832 43.8806,12.6842",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.6%",
    y: "-8.5%",
    width: "109.2%",
    height: "117.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5615,22.9373 C11.5995,22.9373 2.7135,18.3573 2.7135,12.7053 C2.7135,7.0553 11.5995,2.4743 22.5615,2.4743 C33.5245,2.4743 42.4105,7.0553 42.4105,12.7053 C42.4105,18.3573 33.5245,22.9373 22.5615,22.9373 M22.5155,1.1223 C10.6415,1.1223 1.0155,6.2983 1.0155,12.6843 C1.0155,19.0683 10.6415,24.2453 22.5155,24.2453 C34.3905,24.2453 44.0165,19.0683 44.0165,12.6843 C44.0165,6.2983 34.3905,1.1223 22.5155,1.1223",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.7%",
    y: "-8.6%",
    width: "109.3%",
    height: "117.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-18"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.9741,18.1019 C18.9741,18.1019 16.9031,18.2599 16.9151,18.4869 C16.9261,18.7119 18.6231,18.8829 18.9061,18.9159 C19.1891,18.9489 20.2971,19.0749 20.6151,19.1869 C20.9311,19.2989 21.1461,19.3899 21.2711,19.7409 C21.3951,20.0889 21.7011,21.1299 21.7011,21.1299 C21.7011,21.1299 21.8481,21.7049 21.9731,21.7049 C22.0971,21.7049 22.2431,21.0959 22.2431,21.0959 C22.2431,21.0959 22.5501,19.7959 22.7761,19.5599 C23.0011,19.3219 23.0361,19.2319 24.0431,19.0749 C25.0501,18.9159 26.0461,18.7349 26.8051,18.7349 C27.5631,18.7349 27.7101,18.7469 28.1731,18.8019 C28.6391,18.8589 29.6331,18.9829 30.0291,19.1069 C30.4251,19.2309 30.5621,19.5149 30.6631,19.7749 C30.7661,20.0339 30.9911,20.7209 30.9911,20.7209 C30.9911,20.7209 31.0481,21.0049 31.1841,21.0049 C31.3201,21.0049 31.3761,20.7109 31.3761,20.7109 C31.3761,20.7109 31.7391,19.5599 31.9421,19.3799 C32.1461,19.1979 32.2941,19.0279 33.3001,18.9029 C34.3071,18.7789 34.9071,18.6549 35.2581,18.6329 C35.6091,18.6119 35.8571,18.5649 35.8571,18.4529 C35.8571,18.3399 35.7221,18.2969 35.2241,18.2259 C34.7261,18.1599 33.2431,18.0009 32.4621,17.8319 C31.6821,17.6629 31.6371,17.0419 31.5231,16.7359 C31.4101,16.4309 31.3311,15.9469 31.1501,15.9469 C30.9671,15.9469 30.9241,16.2729 30.8901,16.3749 C30.8561,16.4769 30.6751,17.1189 30.5391,17.3339 C30.4031,17.5479 30.3011,17.7869 29.7691,17.8879 C29.2371,17.9889 28.2421,18.2049 27.3031,18.2259 C26.3641,18.2499 25.8311,18.1819 25.0961,18.0919 C24.3611,18.0009 23.6821,17.9669 23.1731,17.7409 C22.6621,17.5149 22.4031,16.7699 22.2671,16.3189 C22.1311,15.8669 22.0411,15.6519 21.9611,15.6519 C21.8821,15.6519 21.7351,15.9909 21.6451,16.2849 C21.5541,16.5789 21.3161,17.4479 20.9661,17.6629 C20.6151,17.8769 20.0261,18.0009 18.9741,18.1019",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.6%",
    y: "-33.0%",
    width: "121.1%",
    height: "166.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-20"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.1357,14.5467 C32.3787,14.5447 31.3817,14.7307 30.3747,14.8927 C29.3677,15.0537 29.3337,15.1457 29.1077,15.3867 C28.8807,15.6287 28.5757,16.9507 28.5757,16.9507 C28.5757,16.9507 28.4287,17.5717 28.3047,17.5717 C28.1797,17.5717 28.0327,16.9867 28.0327,16.9867 C28.0327,16.9867 27.7267,15.9277 27.6027,15.5717 C27.4767,15.2147 27.2647,15.1227 26.9467,15.0077 C26.6287,14.8927 25.5207,14.7657 25.2367,14.7307 C24.9547,14.6967 23.2577,14.5237 23.2457,14.2947 C23.2357,14.0647 25.3047,13.9037 25.3047,13.9037 C26.3577,13.8007 26.9467,13.6727 27.2967,13.4547 C27.6477,13.2357 27.8847,12.3497 27.9767,12.0507 C28.0667,11.7527 28.2127,11.4087 28.2927,11.4087 C28.3727,11.4087 28.4637,11.6247 28.5977,12.0857 C28.7347,12.5457 28.9937,13.3067 29.5047,13.5357 C30.0127,13.7627 30.6927,13.8007 31.4277,13.8907 C31.4277,13.8907 32.3047,14.0607 33.2327,14.0397 C34.1597,14.0147 34.7377,13.8577 35.1007,13.8017 C35.4617,13.7447 36.1407,13.6327 36.3557,13.1357 C36.5707,12.6377 36.7847,11.9167 36.9437,11.9037 C37.1017,11.8927 37.3507,12.6947 37.3507,12.6947 C37.3507,12.6947 37.5317,13.4737 38.1447,13.6107 C38.7537,13.7447 39.7157,13.9697 40.2137,14.0397 C40.7117,14.1057 40.8707,14.1517 40.8707,14.2867 C40.8707,14.4227 40.2037,14.4897 40.2037,14.4897 C40.2037,14.4897 38.4037,14.6927 38.0427,14.9187 C37.6797,15.1447 37.4637,15.3037 37.1927,16.5227 C37.0907,16.8387 37.0687,16.9857 36.9667,16.9857 C36.8647,16.9857 36.6937,16.4767 36.4907,15.7767 C36.2867,15.0767 36.1177,14.8847 35.1107,14.7377 C34.1027,14.5907 33.6737,14.5487 33.1357,14.5467",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-11.3%",
    y: "-32.5%",
    width: "122.7%",
    height: "164.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-22"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.4604,9.6165 L4.9814,9.9555 C4.9814,9.9555 4.5394,9.9725 4.5394,10.1425 C4.5394,10.3125 4.9144,10.3125 5.0484,10.3285 C5.1854,10.3455 7.8334,10.7015 7.8334,10.7015 C7.8334,10.7015 12.0604,11.2765 12.4664,11.3455 C12.8744,11.4135 14.0124,11.5645 14.5034,12.0055 C14.9964,12.4455 15.4214,13.3945 15.7264,14.7995 C16.0314,16.2055 16.3534,17.4075 16.3534,17.4075 C16.3534,17.4075 16.4054,17.8325 16.5734,17.8325 C16.7454,17.8325 16.7954,17.3915 16.7954,17.3915 C16.7954,17.3915 17.6274,14.0885 17.8304,13.5125 C18.0344,12.9365 18.3234,11.7185 20.1734,11.4285 C22.0234,11.1405 25.4684,10.7525 25.4684,10.7525 C25.4684,10.7525 28.8294,10.3455 29.9854,10.4135 C31.1384,10.4805 32.4294,10.6505 32.7524,10.7015 C33.0734,10.7525 33.5944,10.8095 33.8204,11.3725 C34.0464,11.9385 34.2954,12.9995 34.2954,12.9995 C34.2954,12.9995 34.3754,13.3255 34.4994,13.3255 C34.6234,13.3255 34.7034,13.0205 34.7034,13.0205 C34.7034,13.0205 35.0764,11.7345 35.2124,11.4065 C35.3484,11.0795 35.6204,10.7975 36.6264,10.6725 C37.6344,10.5485 38.6984,10.3225 38.6984,10.3225 C38.6984,10.3225 39.2064,10.3125 39.2064,10.1195 C39.2064,9.9275 38.6634,9.9165 38.6634,9.9165 L36.3554,9.5445 C36.3554,9.5445 35.4264,9.4755 35.1904,8.8675 C34.9524,8.2565 34.7034,7.5905 34.7034,7.5905 C34.7034,7.5905 34.6584,7.3195 34.5214,7.3195 C34.3864,7.3195 34.3184,7.6475 34.3184,7.6475 C34.3184,7.6475 34.0464,8.5835 33.8314,8.8895 C33.6164,9.1935 33.3564,9.4985 32.2144,9.6105 C31.0714,9.7245 30.4714,9.8485 30.0184,9.8605 C29.5654,9.8715 28.6264,9.8715 27.8794,9.7815 C27.1334,9.6905 22.3014,9.1035 22.3014,9.1035 C22.3014,9.1035 20.3664,8.8895 19.7544,8.6855 C19.1444,8.4835 18.2484,8.4485 17.5594,6.2905 C16.8694,4.1355 16.8244,3.9775 16.8244,3.9775 C16.8244,3.9775 16.7664,3.5825 16.5734,3.5825 C16.3824,3.5825 16.3264,4.0225 16.3264,4.0225 C16.3264,4.0225 15.5564,6.5175 15.1934,7.2635 C14.8314,8.0075 14.5724,8.7075 11.5504,9.0465 C8.8694,9.3975 7.4604,9.6165 7.4604,9.6165",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.8%",
    y: "-14.0%",
    width: "111.5%",
    height: "128.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-24"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subaru_logo",
    transform: "translate(0.000000, -1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-7"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-9"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-11"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-13"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-15"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-17"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-18)",
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-19"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-20)",
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-23"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-22)",
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-27"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#001457",
    xlinkHref: "#path-23"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-24)",
    xlinkHref: "#path-23"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubaruLogo);
export default __webpack_public_path__ + "static/media/Subaru_logo.9d9ae32d3b097fcd54e8d1ea96d111b2.svg";
export { ForwardRef as ReactComponent };